export default function TimeExpectation() {
  return (
    <section className="py-16 px-6 lg:px-12">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          Takes About 2 Minutes
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          You only need to share basic details about how customers
          <br />
          currently reach you.
        </p>
        <p className="text-base text-gray-600 font-medium">
          I handle the rest.
        </p>
      </div>
    </section>
  );
}
